import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from 'app/shared/auth/services';
import { SharedLayoutMainComponent } from '../shared';
import { UserNotificationsComponent } from './pages/user-notifications/user-notifications.component';

export const routes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'notifications',
        component: SharedLayoutMainComponent,
        children: [
          { path: '', component: UserNotificationsComponent, title: 'User Notifications' },          
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationsRoutingModule { }
